import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { CarouselModule } from 'primeng/carousel';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SidebarModule } from 'primeng/sidebar';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { AccumulatorComponent } from '../components/accumulator/accumulator.component';
import { CalendarComponent } from '../components/calendar/calendar.component';
import { FooterComponent } from '../components/footer/footer.component';
import { Head2headComponent } from '../components/head2head/head2head.component';
import { HeaderComponent } from '../components/header/header.component';
import { LanguageToolbarComponent } from '../components/language-toolbar/language-toolbar.component';
import { LeftSidenavComponent } from '../components/left-sidenav/left-sidenav.component';
import { QuickViewComponent } from '../components/quick-view/quick-view.component';
import { RightSidenavComponent } from '../components/right-sidenav/right-sidenav.component';
import { SideMoreComponent } from '../components/side-more/side-more.component';
import { SplashScreenComponent } from '../components/splash-screen/splash-screen.component';
import { StarterSearchComponent } from '../components/starter-search/starter-search.component';
import { StickyToolbarComponent } from '../components/sticky-toolbar/sticky-toolbar.component';
import { StreamingPlayerComponent } from '../components/streaming-player/streaming-player.component';
import { LoginLayoutComponent } from '../layout/login-layout/login-layout.component';
import { MainLayoutComponent } from '../layout/main-layout/main-layout.component';
import { GetFlagPipe } from '../pipes/get-flag.pipe';
import { SharedModule } from '../shared.module';
import { QuarteRacesComponent } from '../components/quarte-races/quarte-races.component';
import { BlankLayoutComponent } from '../layout/blank-layout/blank-layout.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    CalendarComponent,
    QuickViewComponent,
    AccumulatorComponent,
    StarterSearchComponent,
    Head2headComponent,
    SideMoreComponent,
    MainLayoutComponent,
    LoginLayoutComponent,
    BlankLayoutComponent,
    StickyToolbarComponent,
    LanguageToolbarComponent,
    SplashScreenComponent,
    LeftSidenavComponent,
    RightSidenavComponent,
    StreamingPlayerComponent,
    QuarteRacesComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgbModule,
    TooltipModule,
    SidebarModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    ToastModule,
    AccordionModule,
    CarouselModule,
    DialogModule,
    SharedModule,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    MainLayoutComponent,
    CalendarComponent,
    QuickViewComponent,
    AccumulatorComponent,
    StarterSearchComponent,
    Head2headComponent,
    SideMoreComponent,
    StickyToolbarComponent,
    LanguageToolbarComponent,
    SplashScreenComponent,
    LeftSidenavComponent,
    RightSidenavComponent,
    QuarteRacesComponent,
  ],
  providers: [DatePipe],
})
export class LayoutsModule {}
